<template>
  <el-dialog
    :title="isImportRelorPay ? '导入应收账款' :'导入应付账款'"
    :visible.sync="isShow"
    :before-close="hideAddDialog"
    width="24%"
    style="text-align:center"
    :close-on-click-modal="false"
  >
    <el-upload
      ref="upload"
      class="upload-demo"
      :data="uploadParam"
      action="11"
      auto-upload="false"
      :on-error="uploadFaildAction"
      :on-success="upLoadSuccessAction"
      :http-request="customizeUpload"
      :on-change="fileChanged"
      :file-list="files"
      accept=".xls, .xlsx, .XLS, .XLSX"
      multiple
      drag
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideAddDialog">取 消</el-button>
      <el-button type="primary" @click="submitUpload">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  importReceive, //导入应收账款数据源
  importPay //导入应付账款数据源
} from "../../../services/dataCenterAService";
export default {
  name: "UploadDialog",
  props: {
    isShow: {
      default: false,
      type: Boolean
    },
    isImportRelorPay: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      files: [],
      uploadParam: {},
      fileList: new FormData(),
      importData: [] //导入返回数据
      // uploadParam:{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
    };
  },
  watch: {
    isShow(newValue) {
      if (!newValue) return;
      // this.uploadUrl = this.getUploadUrl();
      console.log(this.uploadUrl);
    }
  },
  methods: {
    fileChanged(file, fileList) {
    },
    hideAddDialog() {
      //关闭导入弹框
      this.$emit("close", this.importData);
      this.$refs.upload.clearFiles();
    },

    //自定义上传事件
    customizeUpload(file) {
      this.fileList = new FormData();
      this.fileList.append("file", file.file);
      // this.submitUpload()
    },
    submitUpload() {
      // this.$refs.upload.submit();
      if (this.isImportRelorPay) {
        //导入应收账款数据源
        importReceive(this.fileList)
          .then(data => {
            if (data.code == 10000000) {
              this.importData = data.data;
              // this.$alert("导入成功", "错误", {
              //   confirmButtonText: "确定",
              //   type: "warning"
              // });
              this.$emit("saveImportItems", this.importData);
              //关闭导入弹框
              this.$emit("close");
              this.isShow = false;
              this.$refs.upload.clearFiles();
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      } else {
        //导入应付账款数据源
        importPay(this.fileList)
          .then(data => {
            if (data.code == 10000000) {
              this.importData = data.data;
              // this.$alert("导入成功", "错误", {
              //   confirmButtonText: "确定",
              //   type: "warning"
              // });
              this.$emit("saveImportItem", this.importData);
              //关闭导入弹框
              this.$emit("close");
              this.isShow = false;
              this.$refs.upload.clearFiles();
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      }
    },
    upLoadSuccessAction(response, file, fileList) {
      // debugger
      // if (response.code == 10000000) {
      //   this.$message.success(response.msg);
      // } else {
      //   this.$message.error(response.msg);
      // }
      this.hideAddDialog();
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    }

    //   //上传图片至服务器
    // uploadGoodsPic() {
    //   // this.hasUnvaildPic=false;
    //   if (this.list.length != 0) {
    //     this.checkFileType();
    //     if (this.hasUnvaildType == false) {
    //       var validList = this.beforeUpload();
    //       if (validList.length == 0) {
    //         this.checkFileType();
    //         this.fileList = new FormData();
    //         this.$refs.upload.submit();
    //         uploadFilesService(this.fileList)
    //           .then(data => {
    //             for(let i=0;i<data.data.length;i++)
    //             {
    //               this.contractItemVOs.push({resource:data.data[i]});
    //             }
    //             if (this.failList.failCount == 0) {
    //               this.$alert("批量上传图片成功", "成功", {
    //                 confirmButtonText: "确定",
    //                 type: "success"
    //               });
    //               this.$emit("saveUpdateFile", this.tableColumnDatas);
    //             } else {
    //               this.warnningDialogVisible = true;
    //             }
    //             this.showUploadGoodsPic = false;
    //           })
    //           .catch(error => {
    //             this.$alert(error, "错误", {
    //               confirmButtonText: "确定",
    //               type: "warning"
    //             });
    //           });
    //       } else {
    //         this.warnningName();
    //       }
    //     } else {
    //       this.$alert("仅支持'jpeg'、'jpg'和'png'格式的图片哦", "错误", {
    //         confirmButtonText: "确定",
    //         type: "warning"
    //       });
    //     }
    //   } else {
    //     this.$alert("请选择您要上传的图片", "提示", {
    //       confirmButtonText: "确定",
    //       type: "warning"
    //     });
    //   }
    // }
  }
};
</script>

<style scoped>
/deep/.el-upload-dragger {
  width: 100%;
}
</style>